<template>
	<div class="body">
		<Header></Header>
		<div class="block">
			<div class="banner_innovation"></div>
			<div class="menu_block">
				<div class="content fsb">
					<dl class="menu">
						<dd>
							<a class="select" href="#innovation_1">本体激励电机特点</a>
						</dd>
						<dd>
							<a href="#innovation_2">控制系统解析</a>
						</dd>
					</dl>
					<div class="location">
						当前位置：
						<a href="/">首页</a>
						<i class="icon el-icon-arrow-right"></i>
						<a href="">技术创新</a>
					</div>
				</div>
			</div>

			<div class="content">
				<div class="title_01 mt70" id="innovation_1">本体激励电机特点</div>

				<div class="text_block mt30">
					<p>本体激励电机定子采用特殊结构大幅降低磁化电流，转子无需外加能量本体就可激励磁场。应用中凸显“四高四低”的特点：高效率、高功率因数、高精控、高稳定性和低电流、低污染、低噪音、低温升。</p>
					<p><strong>1、高效率：</strong>效率超过GB18613-2020《电机能效限定值及能效等级》、GB30253-2013《永磁同步电动机能效限定值及能效等级》中一级效能指标。高效率区域广阔，在0-120%负荷率范围内具有稳定的高效值。</p>
					<p><strong>2、高功率因数：</strong>功率因数始终接近1，大幅降低供电网络功率损耗。</p>
					<p><strong>3、高精控：</strong>专用控制器及控制系统可储存生产工艺程序并根据生产要求调用自动运行，同时通过组网集中控制，精准把控电机状态。对电机和拖动设备机械部分起到保护作用，延长使用寿命，减少维护。</p>
					<p><strong>4、高稳定性：</strong>本体激励系统在电机运行时，实时监测电机运行数据并储存，通过独特算法及大数据评估，实现电机故障的提前预警及自动保护功能。本体激励电机运行由0-额定转速平滑启动无冲击，对电机和拖动设备机械部分起到保护作用，延长使用寿命，减少维护。</p>
					<p><strong>5、低电流：</strong>本体激励电机空载电流为额定电流的1%，是传统异步电机空载电流的1/20。运行电流平均下降30%，大幅减少动力线路损耗，减少电缆投入成本，降低变压器负荷。</p>
					<p><strong>6、低污染：</strong>低速大转矩，取消各种减速器直接驱动，减少油污染。</p>
					<p><strong>7、低噪音：</strong>本体激励电机省去了减速器等机械传动结构，机械传动效率大幅提高接近100%，噪声明显降低，噪声可低于55dB 以下。</p>
					<p><strong>8、低温升：</strong>由于本体激励电机转子损耗几乎为0，定子损耗远低于传统电机，电机热损耗只有传统电机的40%，电机温升低于50K，远远低于传统电机80K的标准值，大幅提高电机的环境适应能力。</p>
				</div>
			</div>

			<div class="bg mt70" style="margin-bottom:-80px">
				<div class="content">
					<div class="title_01" id="innovation_2">控制系统解析</div>
					<div class="text_block mt30">
						<p><strong>边界扫描技术（border scan）：</strong>新开发的边界扫描系统是一款高效、高速的电网设备检测系统，它可以快速的检测出电网中的瞬压、瞬流、各种谐波、高频波、多次波、回馈波等有害成份，同时，它可以在任何条件下采集设备的运转状况，如电动机的转速、力矩、瞬时频率等参数，最后把采集到的数据打包后传递到计算机进行处理。</p>
						<p class="mt40"><strong>回旋抗电流产生技术（answer resist）：</strong>新开发的answer resist技术可以在任何形成的负载在能量交换后的第一个周期内产生一个相位和电流方向与系统电网相反的电流，来迅速阻断电网电流的通过，此时负载完全没有消耗电网中的能量。待到border scan系统检测到负载能量将要消失的最后一个周期，answer resist系统将撤消叠加在系统电网上的电流使负载迅速得到能量来维持运转，以此方式周期性的运行下去，可以节省电网大量的有功功率。</p>
						<p class="mt40"><strong>电荷泵陈列技术（electricity pump）：</strong>电荷泵矩阵器件，开发出electricity pump系统。此系统的高低频滤波器，可以在第一时间内迅速的把电网中的瞬压、瞬流、高频波、多次波，回馈波等有害杂波电压引入到电荷泵矩阵内，这样，不仅达到了消除电网谐波的目地，同时把引入电荷泵的有害杂波电压，通过整形、降频、稳压等技术，逆变电源回馈给储能器。它可以在积累到一定程度时，迅速的断开电网电压，把电荷泵积累的能量叠加回馈到负载中，此时负载所使用的能量是电荷泵中回馈的能量，所以大量节省了电网的能量。</p>
						<p class="mt40"><strong>起动冲击节能：</strong>本体激励电动机运行是由0转速启动，逐渐加速到额定转速，无启动转矩冲击，对电机轴和拖动设备轴起到保护作用。</p>
						<div class="img mt40">
							<img src="../images/img_05.png" alt="">
						</div>
					</div>
				</div>
			</div>

		</div>
		<Footer></Footer>
	</div>
</template>

<script>
import Header from '../components/hearder.vue'
import Footer from '../components/footer.vue'

export default {
	data() {
		return {
			activeName: '1'
		}
	},
	components: {
		Header,
		Footer
	},

	methods: {
		
	}
}
</script>

<style lang="less" scoped>


</style>
